const MIGRATED_NETWORK_IDS = [
  // CHC - Community Health Choice TX
  23100,
  // Parkland
  11001,
  // Partners Behavioral Health Management
  5001,
  // Lakeland Medicaid
  22100,
  // Molina TX DNSP
  103000,
  // Molina OH DNSP
  104000,
  // Molina WA DNSP
  105000,
  // Molina UT DNSP
  106000,
  // UHC
  9400,
  // Wellcare IN
  82300,
  // Molina TX
  10200,
  // Molina FL
  10500,
  // BCBS Arkansas
  20400,
  // Aetna BH LA
  13001,
  // Aetna IL
  13011,
];

const MIGRATED_GROUP_IDS = [
  // Aetna BH FL
  13131, // General Medicaid
  13132, // Pregnancy
  // Aetna BH KY
  13501, // General Medicaid
  13503, // Pregnant
  13502, // SKY Members 18+
  // Aetna BH LA
  13102, // Pregnancy
  13001, // Aetna
  // Aetna BH OK
  13161, // Medicaid
  // Aetna BH TX
  13303, // CHIP
  13304, // CHIP Pregnant
  13301, // STAR
  13305, // STAR 18+
  13302, // STAR Pregnant
  // Aetna Mercy Care AZ
  13201, // AHCCCS
  13209, // AHCCCS Perinatal
  13202, // ALTCS
  13203, // DD
  13205, // INTG
  13208, // LTCMCA
  13207, // MCA
  13206, // NT
  // Aetna MI
  13141, // General Medicaid
  13142, // Pregnancy
  // Centene - Network 8001
  8001, // Medicaid
  8103, // Wellcare
  8102, // Wellcare by Allwell
  8104, // Ambetter
  // Centene - Network 8200
  8201, // STAR
  8202, // STAR HEALTH
  8203, // STAR+PLUS
  8204, // STAR+PLUS MMP
  8205, // Allwell
  8206, // Ambetter
  // Centene - Network 8300
  8301, // HMO
  8302, // HMO SNP
  8303, // Legacy
  8304, // Medicaid General
  8305, // Medicaid Pregnant
  // Centene - Network 81100
  81102, // Medicaid
  81103, // Pregnancy
  // Centene - Network 81300
  81301, // Medicaid
  // Centene - Network 81400
  81402, // Exchange
  81401, // Medicaid
  // Centene - Network 81500
  81503, // MMP
  // Centene - Network 81600
  81601, // Medicaid Adult
  // Centene - Network 81700
  81701, // Ambetter
];

export const isMigrated = (networkId, groupId) =>
  MIGRATED_NETWORK_IDS.includes(networkId) || MIGRATED_GROUP_IDS.includes(groupId);
